<div class="login-page">
    <div class="login-bg-img">
        <img src="./assets/images/login-bg-img.webp" alt="">
    </div>


    <div class="container">
        <div class="login-container">
            <div class="welcome">
                <h2>404! Not Found</h2>
            </div>
        </div>
    </div>
</div>